import { Purchase } from '../purchases/purchase.model';

export class Email {
  idPurchase?: number;
  purchase?: Purchase;
  username?: string;
}
